import { Component } from '@angular/core';

@Component({
  selector: 'selfcare-unsaved-changes',
  styleUrls: ['unsaved-changes.components.scss'],
  templateUrl: 'unsaved-changes.component.html'
})
export class UnsavedChangesComponent {}
